// extracted by mini-css-extract-plugin
export default {"form":"SecondComponent_form__3Ojxk","control":"SecondComponent_control__u3Xa-","input":"SecondComponent_input__0Uxi1"};